// extracted by mini-css-extract-plugin
export var headerCell = "_42-1";
export var loadingSpinnerContainer = "_42-4";
export var rowWrapper = "_42-3";
export var standaloneTable = "_42-5";
export var table = "_42-0";
export var white = "_42-2";